import { AppTooltip } from '@/components/base/AppTooltip';
import { projectListStyles as s } from './ProjectList.styles';

let compact: Intl.DateTimeFormat | undefined;
let precise: Intl.DateTimeFormat | undefined;
export function ProjectLastOpened({
  id,
  timestamp,
}: {
  id?: string;
  timestamp?: number;
}) {
  if (timestamp === undefined)
    return (
      <span className={s.date}>
        <span aria-hidden="true">—</span>
        <span id={id} className="sr-only">
          Last opened unknown
        </span>
      </span>
    );
  const date = new Date(timestamp);
  precise ??= new Intl.DateTimeFormat(undefined, {
    dateStyle: 'full',
    timeStyle: 'long',
  });
  compact ??= new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
  const exact = precise.format(date);
  return (
    <AppTooltip content={exact} openOnTargetFocus={false}>
      <time
        className={s.date}
        dateTime={date.toISOString()}
        aria-label={`Last opened ${exact}`}
      >
        <span aria-hidden="true">{compact.format(date)}</span>
        <span id={id} className="sr-only">
          Last opened {exact}
        </span>
      </time>
    </AppTooltip>
  );
}
